import React, { useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import { Button, Typography } from '@material-ui/core'
import { formStyles } from '../../components/Invoice/Steps/FormStyles'
import FormSelectField from '../FormSelectField'
import FormTextField from '../FormTextField'
import { useFormik } from 'formik'
import Alert from '@material-ui/lab/Alert'
import { LateSubmissionNewRequest } from '../../utils/validationSchema'
import { LateSubmissionContext } from '../../context/LateSubmissionContext'
import { FormLoader } from '../../components/Loader/FormLoader'

const LateSubmissionForm = ({ cancelDialog, onSubmit, locale }) => {
  let { lateSubmissionConf, lateSubmissionConfLoading, lateSubmissionReasons, lateSubmissionReasonsLoading, getLateSubmissionReasons } = useContext(LateSubmissionContext)
  const classes = formStyles()
  const formActions = useFormik({
    initialValues: {
      reasonId: '',
      reasonDescription: ''
    },
    validateOnBlur: false,
    validateOnChange: true,
    validateOnMount: true,
    isInitialValid: false,
    validationSchema: LateSubmissionNewRequest,
    onSubmit: ((values, formikHelpers) => {
      onSubmit(values, formikHelpers)
    })
  })

  React.useEffect(() => {
      if (!!getLateSubmissionReasons) {
        getLateSubmissionReasons()
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [])
  return (
    <form noValidate autoComplete="off"
          className={classes.formWrapper}>

      <Typography className={classes.hintWrapper + ' ' + classes.FormRow} variant={'subtitle1'} paragraph>
        <FormattedMessage id='lateSubmissionText'
                          values={{
                            strong: chunks => <strong>{chunks}</strong>,
                            window: lateSubmissionConf?.lateSubmissionWindow || 1,
                            gracePeriod: lateSubmissionConf?.lateSubmissionInvoiceGracePeriod || lateSubmissionConf?.lateSubmissionPeriod || 24
                          }}/>
      </Typography>

      <FormSelectField name={'reasonId'} labelKey={'Fields.label.reason'}
                       classes={classes} loading={lateSubmissionReasonsLoading} formActions={formActions}
                       required row displayEmpty list={lateSubmissionReasons} locale={locale}/>

      {formActions.values.reasonId === '1' && <>
        <FormTextField name={'reasonDescription'} labelKey={'Fields.label.reasonText'}
                       classes={classes} formActions={formActions} row required lines={3}/>
      </>
      }
      <Alert severity="warning">
        <FormattedMessage id='LateSubmission.AlertWarning'/>
      </Alert>
      <div className={classes.FormSubmitRow}>
        <Button variant='contained' size={'large'} color={'secondary'}
                onClick={formActions.handleSubmit}
                disabled={formActions.isSubmitting || !formActions.isValid}
        >
          <FormattedMessage id={'LateSubmission.Submit'}/>
        </Button>
        <Button variant='outlined' color='secondary'
                onClick={cancelDialog} className={'cancel'}>
          <FormattedMessage id='LateSubmission.Cancel'/>
        </Button>
      </div>
      {(!!lateSubmissionConfLoading || !!formActions.isSubmitting) && <FormLoader loading={true}/>}
    </form>
  )
}
export default LateSubmissionForm